import { z } from 'zod/v4';

import { styleBagSchema } from '../../../common/schemas/legacy';

import { accordionLegacyDataSchema } from './data';

/**
 * Legacy `accordion` widget envelope — its only placement (`params: defaultWidgetParams`
 * unmodified, i.e. `type: ['default']`; never `'zero'`/`'specific'`). No `type` discriminator,
 * same reasoning as indent/logo/navigation/menu: single shape, created via the plain-widget
 * factory path that never stamps one.
 */
export const accordionLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('accordion'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    data: accordionLegacyDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
